import is from '@sindresorhus/is';
import { intlFormat } from 'date-fns/intlFormat';
import type { FunctionComponent } from 'react';
import { useContext, useMemo } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { CustomAttributeWithValue } from '~/shared/data-contract/custom-attribute';

import { DataCell } from '../../../../../design/components/data-grid/DataGridContainer';

type CustomAttributeComponentProps = {
    readonly attribute: CustomAttributeWithValue;
};

export const CustomAttributeComponent: FunctionComponent<CustomAttributeComponentProps> = (props) => {
    const { applicationState, translate } = useContext(ApplicationContext);
    const { language } = applicationState;

    const renderValue: string | null | undefined = useMemo(() => {
        if (is.null(props.attribute.value)) {
            return null;
        }

        switch (props.attribute.type) {
            case 'boolean':
                return props.attribute.value ? translate('common.yes') : translate('common.no');
            case 'date':
                return intlFormat(new Date(props.attribute.value), { locale: language.code });
            default:
                return translate(`attributes.user.${props.attribute.name}-options.${props.attribute.value}`, {
                    defaultValue: props.attribute.value,
                });
        }
    }, [props.attribute.value, props.attribute.type, props.attribute.name, language.code, translate]);

    if (is.nonEmptyString(renderValue)) {
        return <DataCell label={translate(`attributes.user.${props.attribute.name}`)} value={renderValue} />;
    }

    return null;
};
